var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _objectWithoutProperties = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;

var _excluded = ["className", "isPressed"];

/*! For license information please see wp-primitives.js.LICENSE.txt */
!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/primitives"] = t() : (e.wp = e.wp || {}, e.wp.primitives = t());
}(self, function () {
  return e = {
    424: function _(e) {
      e.exports = function _interopRequireDefault(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
    },
    223: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.BlockQuotation = void 0, t.BlockQuotation = "blockquote";
    },
    906: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.HorizontalRule = void 0, t.HorizontalRule = "hr";
    },
    262: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = r(789);
      Object.keys(o).forEach(function (e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
          enumerable: !0,
          get: function get() {
            return o[e];
          }
        }));
      });
      var n = r(906);
      Object.keys(n).forEach(function (e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
          enumerable: !0,
          get: function get() {
            return n[e];
          }
        }));
      });
      var i = r(223);
      Object.keys(i).forEach(function (e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
          enumerable: !0,
          get: function get() {
            return i[e];
          }
        }));
      });
      var a = r(474);
      Object.keys(a).forEach(function (e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
          enumerable: !0,
          get: function get() {
            return a[e];
          }
        }));
      });
    },
    789: function _(e, t, r) {
      "use strict";

      var o = r(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Stop = t.SVG = t.Rect = t.RadialGradient = t.Polygon = t.Path = t.LinearGradient = t.G = t.Defs = t.Circle = void 0;
      var n = o(r(703)),
          i = r(753);
      t.Circle = function (e) {
        return (0, i.createElement)("circle", e);
      }, t.G = function (e) {
        return (0, i.createElement)("g", e);
      }, t.Path = function (e) {
        return (0, i.createElement)("path", e);
      }, t.Polygon = function (e) {
        return (0, i.createElement)("polygon", e);
      }, t.Rect = function (e) {
        return (0, i.createElement)("rect", e);
      }, t.Defs = function (e) {
        return (0, i.createElement)("defs", e);
      }, t.RadialGradient = function (e) {
        return (0, i.createElement)("radialGradient", e);
      }, t.LinearGradient = function (e) {
        return (0, i.createElement)("linearGradient", e);
      }, t.Stop = function (e) {
        return (0, i.createElement)("stop", e);
      }, t.SVG = function (e) {
        var t = e.className,
            r = e.isPressed,
            o = _objectWithoutProperties(e, _excluded);

        var a = _objectSpread(_objectSpread({}, o), {}, {
          className: (0, n.default)(t, {
            "is-pressed": r
          }) || void 0,
          role: "img",
          "aria-hidden": !0,
          focusable: !1
        });

        return (0, i.createElement)("svg", a);
      };
    },
    474: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.View = void 0, t.View = "div";
    },
    703: function _(e, t) {
      var r;
      !function () {
        "use strict";

        var o = {}.hasOwnProperty;

        function classNames() {
          for (var e = [], t = 0; t < arguments.length; t++) {
            var r = arguments[t];

            if (r) {
              var n = typeof r;
              if ("string" === n || "number" === n) e.push(r);else if (Array.isArray(r)) {
                if (r.length) {
                  var i = classNames.apply(null, r);
                  i && e.push(i);
                }
              } else if ("object" === n) if (r.toString === Object.prototype.toString) for (var a in r) {
                o.call(r, a) && r[a] && e.push(a);
              } else e.push(r.toString());
            }
          }

          return e.join(" ");
        }

        e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (r = function () {
          return classNames;
        }.apply(t, [])) || (e.exports = r);
      }();
    },
    753: function _(e) {
      "use strict";

      e.exports = require("@wordpress/element");
    }
  }, t = {}, r = function __webpack_require__(r) {
    var o = t[r];
    if (void 0 !== o) return o.exports;
    var n = t[r] = {
      exports: {}
    };
    return e[r](n, n.exports, __webpack_require__), n.exports;
  }(262), r;
  var e, t, r;
});